
import { ElForm } from 'element-plus'
import { defineComponent, ref, toRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import FormControl from '@/components/form/common/FormControl.vue'
import { useClickLock } from '@/utils/useClickLock'

export default defineComponent({
  components: { FormControl },
  props: {
    formModel: {
      type: Object,
      default: () => {
        return null
      }
    },
    formStruct: {
      type: Array,
      default: () => []
    },
    formRules: {
      type: Object,
      default: () => {
        return null
      }
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    },
    labelWidth: {
      type: String,
      required: false,
      default: '150px'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    itemSpan: {
      type: Number,
      required: false,
      default: 7
    },
    itemOffset: {
      type: Number,
      required: false,
      default: 3
    },
    hadSlot: {
      type: Boolean,
      default: false
    },
    slotSpan: {
      type: Number,
      default: 2
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const rFormRef = ref(ElForm)
    const fM = ref(props.formModel)
    const fS = ref(props.formStruct)
    const fR = ref(props.formRules)
    const { disabled: submitDisabled, lock: submitLock } = useClickLock(2000)
    const { disabled: resetDisabled, lock: resetLock } = useClickLock(2000)
    const submitEmit = () => {
      rFormRef.value.validate((valid: any) => {
        if (valid) {
          submitLock(() => {
            context.emit('submit', toRaw(fM.value))
          })
        }
      })
    }
    const resetEmit = () => {
      resetLock(() => {
        (rFormRef.value as typeof ElForm).resetFields()
        context.emit('reset')
      })
    }
    return {
      t,
      fM,
      fS,
      fR,
      rFormRef,
      submitDisabled,
      resetDisabled,
      submitEmit,
      resetEmit
    }
  }
})
